import { getAllActiveEmployees } from "../../../utils/api";
import { CustomError, OpportunityStatusList } from "../../../utils/data";
import { fetchWrapper } from "../../../utils/misc";
import { initialFunnelFilterState } from "./EmployeesGraph.data";

export const getQuarterTarget = async (loginIdToFilter, year, empStatus = 0) => {
    try {
        const req = await fetch(
            `${localStorage.getItem("BaseUrl")}/Tracking/AllDarQuarterTarget2?LOGINID=${loginIdToFilter}&Year=${year}&EmpStatus=${empStatus}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
                },
            }
        );

        if (req.ok) {
            const res = await req.json();

            if (res.resCode === 200) {
                // for normal targets
                let cats = [];
                // for revenue targets
                let revs = [];
                for (let key in res.resData) {
                    if (res.resData[key] !== null && key.includes("target")) {
                        cats.push({
                            [key.includes("target") && "target"]: res.resData[key],
                            actualKey: key
                        });
                    }

                    if (res.resData[key] !== null && key.includes("revenue")) {
                        revs.push({
                            [key.includes("revenue") && "revenueTarget"]: res.resData[key],
                            actualKey: key
                        });
                    }
                }

                const updatedRevenueData = revs.map(revTarget => {
                    return {
                        revenueTarget: Math.round(Number.parseFloat(revTarget.revenueTarget) * 100000),
                        key: revTarget.actualKey,
                        quarter: +(revTarget.actualKey.slice(revTarget.actualKey.length - 1))
                    }
                });

                const updatedData = cats.map(target => {
                    return {
                        target: Math.round(Number.parseFloat(target.target) * 100000),
                        key: target.actualKey,
                        quarter: +(target.actualKey.slice(target.actualKey.length - 1))
                    }
                });

                const totalYearTarget = updatedData.reduce((total, targetObj) => {
                    total += targetObj.target;
                    return total;
                }, 0);

                const totalYearRevenueTarget = updatedRevenueData.reduce((total, targetObj) => {
                    total += targetObj.revenueTarget;
                    return total;
                }, 0);

                const b = updatedData.filter((item, idx, arr) => {
                    const { key } = item;
                    const valueVertical = arr.reduce((v, i) => {
                        const vertical = i.key.split('target')?.[1].slice(0, 3);
                        if(i.target > 0) v = vertical;
                        return v;
                    }, null);

                    if(key.includes(valueVertical)) {
                        return item;
                    }
                });

                const c = updatedRevenueData.filter((item, idx, arr) => {
                    const { key } = item;
                    const valueVertical = arr.reduce((v, i) => {
                        const vertical = i.key.split('revenue')?.[1].slice(0, 3);
                        if(i.target > 0) v = vertical;
                        return v;
                    }, null);

                    if(key.includes(valueVertical)) {
                        return item;
                    }
                })

                if (typeof totalYearTarget === "number" && typeof totalYearRevenueTarget === "number") {
                    return {
                        totalYearRevenueTarget,
                        totalYearTarget,
                        updatedData: b,
                        updatedRevenueData: updatedRevenueData.filter(item => item.revenueTarget > 0)
                    }
                } else {
                    return null;
                }
            } else {
                console.log("Response error", res);
            }
        } else {
            console.log("Request error", req);
        }
    } catch (err) {
        console.log(err.message);
    }
};

export const getQuarterAchievementPrice = async (loginIdToFilter, year) => {
    const result = await fetchWrapper("GET", `${localStorage.getItem("BaseUrl")}/Dar/QuarterAchePriceByEmpid?LOGINID=${loginIdToFilter}&Year=${year}`, null);
    if (result.resCode === 200) {
        return {
            achPrice: result?.resData?.achPrice,
            revenueAchPrice: result?.resData?.revenueAchPrice,
            completedTargetAmt: result?.resData?.achPrice?.q1_AchPrice + result?.resData?.achPrice?.q2_AchPrice + result?.resData?.achPrice?.q3_AchPrice + result?.resData?.achPrice?.q4_AchPrice,
            completedRevenueTargetAmt: result?.resData?.revenueAchPrice?.q1_RevenueAchPrice + result?.resData?.revenueAchPrice?.q2_RevenueAchPrice + result?.resData?.revenueAchPrice?.q3_RevenueAchPrice + result?.resData?.revenueAchPrice?.q4_RevenueAchPrice
        }
    }
}

export const getSelectedEmployeeName = async (employeeId) => {
    const result = await getAllActiveEmployees();
    if (result.resCode === 200) {
        const data = result.resData;

        const selectedEmployee = data.find(employee => employee.employeeId === employeeId);
        if (selectedEmployee) {
            return selectedEmployee;
        } else {
            return null;
        }
    } else {
        return null;
    }
}

export const getAchPriceOfAllQuarters = (achPriceData) => {
    if (typeof achPriceData === "object" && achPriceData !== null && !Array.isArray(achPriceData)) {
        const entries = Object.entries(achPriceData);

        const convertedObj = entries.reduce((acc, item) => {
            let total = 0;
            const [key, value] = item;

            value.forEach(item => {
                total += item.achValue;
            });

            acc[key] = total;
            return acc;
        }, {});

        return convertedObj;
    } else {
        throw new Error(`passed parameter must be an object`);
    }
}

export const getRevenueAchPriceOfAllQuarters = (achPriceData) => {
    if (typeof achPriceData === "object" && achPriceData !== null && !Array.isArray(achPriceData)) {
        const entries = Object.entries(achPriceData);

        const convertedObj = entries.reduce((acc, item) => {
            let total = 0;
            const [key, value] = item;

            value.forEach(item => {
                total += item.payment;
            });

            acc[key] = total;
            return acc;
        }, {});

        return convertedObj;
    } else {
        throw new Error(`passed parameter must be an object`);
    }
}

export const getQuarterFunnel = async (quarterStr, loginUserId, year, callStatusId) => {
    const reqUrl = `${localStorage.getItem("BaseUrl")}/Tracking/AllOpenDarEntry?loginid=${loginUserId}&CallStatusId=${callStatusId}&Year=${year}`;
    const result = await fetchWrapper("GET", reqUrl, null, true);
    let funnelData = [];
    if (result.resCode === 200) {
        const data = result.resData;

        for (let key in data) {
            if (key === quarterStr) {
                funnelData = data[key];
            }
        }
    }

    return funnelData;
}

export const getYearlyFunnel = async (loginUserId, callStatusId, year) => {
    const reqUrl = `${localStorage.getItem("BaseUrl")}/Tracking/AllOpenDarEntry?loginid=${loginUserId}&CallStatusId=${callStatusId}&Year=${year}`;
    const result = await fetchWrapper("GET", reqUrl, null, true);
    let funnelData = [];
    if (result.resCode === 200) {
        const data = result.resData;

        for (let key in data) {
            if (key !== 'yearly') {
                funnelData.push(...data[key]);
            }
        }
    }

    return funnelData;
}

export const generateFunnelColumns = (funnelData) => {
    const employeeListFromData = [];

    if (funnelData.length > 0) {
        funnelData.filter((row) => {
            if (!employeeListFromData.includes(row.empName)) {
                employeeListFromData.push(row.empName);
            } else {
                return;
            }
        });
    }

    const columns = [
        {
            title: "Lead Id",
            dataIndex: "leadId",
            key: "leadId",
            width: "10%",
            sorter: (a, b) => a.leadId - b.leadId,
        },
        {
            title: "Dar Id",
            dataIndex: "darId",
            key: "darId",
            width: "7%",
            sorter: (a, b) => a.darId - b.darId,
            onHeaderCell: () => ({
                whitespace: 'nowrap'
            }),
        },
        {
            title: "Principal",
            dataIndex: "principleName",
            key: "principleName",
            width: "15%",
            onHeaderCell: () => ({
                whitespace: 'nowrap'
            }),
            filters: [
                {
                    text: 'CYME',
                    value: 'CYME',
                },
                {
                    text: 'Primtech',
                    value: 'Primtech',
                },
                {
                    text: 'SKM',
                    value: 'SKM',
                },
                {
                    text: 'Techlabs Project PSG',
                    value: 'Techlabs Project PSG',
                },
            ],
            onFilter: (value, record) => record.principleName.indexOf(value) === 0,
        },
        {
            title: "Product",
            dataIndex: "productName",
            key: "productName",
            width: "20%"
        },
        {
            title: "Price",
            dataIndex: "price",
            key: "price",
            width: "10%",
            render: (price) => {
                return `${(price / 100000).toFixed(2)} Lac`
            }
        },
        {
            title: "Customer",
            dataIndex: "custName",
            key: "custName",
            onCell: () => ({
                style: { whiteSpace: 'nowrap' }, // Data cell styles
            }),
        },
        {
            title: "Employee",
            dataIndex: "empName",
            key: "empName",
            onCell: () => ({
                style: { whiteSpace: 'nowrap' }, // Data cell styles
            }),
            width: "15%",

            filters: employeeListFromData.map(emp => {
                return {
                    text: emp,
                    value: emp
                }
            }),
            onFilter: (value, record) => record.empName.indexOf(value) === 0,
        },
        {
            title: "Month of Order",
            dataIndex: "monthOfOrder",
            key: "monthOfOrder",
            width: "10%",
            render: (monthOfOrder) => {
                const dateObj = new Date(monthOfOrder);
                const monthDate = dateObj.getDate() < 10 ? `0${dateObj.getDate()}` : dateObj.getDate();
                const month = (dateObj.getMonth() + 1) < 10 ? `0${dateObj.getMonth() + 1}` : dateObj.getMonth() + 1;
                const year = dateObj.getFullYear();
                return `${monthDate}-${month}-${year}`;
            }
        },
        {
            title: "Opportunity Status",
            dataIndex: "darStageId",
            key: "darStageId",
            width: '20%',
            onCell: () => ({
                style: { whiteSpace: 'nowrap' }, // Data cell styles
            }),
            render: (darStageId) => {
                const opStatus = OpportunityStatusList.find(item => item.id === darStageId);
                if (opStatus) {
                    return opStatus.value;
                } else {
                    return "Not Available";
                }
            },

            filters: OpportunityStatusList.map(item => ({ text: item.value, value: item.id })),
            onFilter: (value, record) => record.darStageId === value,
        },
    ];

    return columns;
}

export const quarterTotalDarPrice = (quarterArr) => {
    if (quarterArr.length > 0) {
        const totalPrice = quarterArr.reduce((total, value) => {
            total += value.price;
            return total;
        }, 0);
        return totalPrice;
    }
    return 0;
}

export const quarterCustomers = (quarterArr) => {
    if (quarterArr.length > 0) {
        console.log(quarterArr);
    }
    return 0;
}

export const funnelCustomerReducer = (state, action) => {
    if (action.type === "loading") {
        return {
            ...state,
            loading: true
        }
    } else if (action.type === "loaded") {
        return {
            ...state,
            loading: false
        }
    } else if (action.type === "addQ1") {
        return {
            ...state,
            q1: action.value,
        }
    } else if (action.type === "addQ2") {
        return {
            ...state,
            q2: action.value,
        }
    } else if (action.type === "addQ3") {
        return {
            ...state,
            q3: action.value
        }
    } else if (action.type === "addQ4") {
        return {
            ...state,
            q4: action.value,
        }
    } else if (action.type === "addYearly") {
        return {
            ...state,
            yearly: action.value,
        }
    } else if (action.type === "setActiveQuarter") {
        return {
            ...state,
            activeFunnelQuarterModal: action.value
        }
    } else if (action.type === "error") {
        return {
            ...state,
            loading: false,
            error: action.value
        }
    }

    else {
        return state;
    }
}

export const filterReducer = (state, action) => {
    if (action.type === "CALL_STATUS") {
        return {
            ...state,
            callStatusId: action.value
        }
    } else if (action.type === "RESET") {
        return initialFunnelFilterState;
    }
}

export const getFunnelData = async (loginUserId, callStatusId = 0, year) => {
    const reqUrl = `${localStorage.getItem("BaseUrl")}/Tracking/AllOpenDarEntry?loginid=${loginUserId}&CallStatusId=${callStatusId}&Year=${year}`;
    const result = await fetchWrapper("GET", reqUrl, null, true);
    if (result instanceof Error || result instanceof CustomError) {
        throw new Error('Some error occurred');
    }
    let funnelData = [];
    if (result.resCode === 200) {
        const data = result.resData;
        funnelData = data;
    }

    return funnelData;
}

export const generateCSVData = (data = []) => {
    const dataForCSV = data.map((item) => {
        const opStatus = OpportunityStatusList.find(opStatus => opStatus.id === item.darStageId);
        const {
            custName,
            darId,
            darStatus,
            empName,
            leadId,
            monthOfOrder,
            price,
            principleName,
            productName,
            vertical
        } = item;

        return {
            "Customer Name": custName,
            "DAR ID": darId,
            "DAR Status": darStatus,
            "Employee Name": empName,
            "Lead ID": leadId,
            "Month Of Order": monthOfOrder,
            "Price": price,
            "Principal": principleName,
            "Product": productName,
            "Vertical": vertical,
            "Opportunity Status": opStatus.value ? opStatus.value : "N/A"
        }
    });

    return dataForCSV || [];
}

export const getYearsList = () => {
    const yearList = [];

    for (let i = 2015; i <= new Date().getFullYear(); i++) {
        yearList.push({
            key: i + 1,
            value: i + 1,
            text: `${i}-${i + 1}`
        });
    }

    return yearList.reverse();
}